export const BASE_URL = process.env.VUE_APP_API_BASE_URL

export const REQUEST_TIMEOUT = 1000 * 60

export const DEFAULT_DELIMITER = '|'
